import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget-max-values',
  templateUrl: './widget-max-values.component.html',
  styleUrls: ['./widget-max-values.component.css']
})
export class WidgetMaxValuesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
